import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router";
import { canSendGaEvents } from "src/libs/analytics";

type PageViewProps = {
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  time?: Date;
};

export const usePageView = (props?: PageViewProps): void => {
  const location = useLocation();
  useEffect(() => {
    if (!canSendGaEvents()) {
      return;
    }
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      eventCategory: props?.eventCategory,
      eventAction: props?.eventAction,
      eventLabel: props?.eventLabel,
      time: props?.time,
      referrer: document.referrer || undefined,
      location: window.location.href,
    });
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");

    if (utmSource) {
      localStorage.setItem("utm_source", utmSource);
    }
  }, [
    location.pathname,
    location.search,
    props?.eventCategory,
    props?.eventAction,
    props?.eventLabel,
    props?.time,
  ]);
};
